module.exports = __webpack_public_path__ + "img/OutOfQuestionsSmiley.a6cc1c3c.svg";